import React, { useState } from 'react';
import './styles/ProductImages.css';
import './styles/ProductImages.mobile.css';

interface ProductImagesProps {
  mainImage: string;
  thumbnailImages: string[];
  productName: string;
  onZoomChange?: (data: { xPercent: number; yPercent: number; imageSrc: string }) => void;
  onZoomEnd?: () => void;
  isDesktop?: boolean;
}

const ProductImages: React.FC<ProductImagesProps> = ({
  mainImage,
  thumbnailImages,
  productName,
  onZoomChange,
  onZoomEnd,
  isDesktop
}) => {
  const [selectedImage, setSelectedImage] = useState(mainImage);

  // Sync selectedImage with mainImage prop (for variant selection)
  React.useEffect(() => {
    setSelectedImage(mainImage);
  }, [mainImage]);

  const handleThumbnailClick = (image: string) => {
    setSelectedImage(image);
  };

  const handleMouseMove: React.MouseEventHandler<HTMLDivElement> = (event) => {
    if (!isDesktop || !onZoomChange) return;

    const rect = event.currentTarget.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    const xPercent = Math.min(100, Math.max(0, x));
    const yPercent = Math.min(100, Math.max(0, y));

    onZoomChange({
      xPercent,
      yPercent,
      imageSrc: selectedImage
    });
  };

  const handleMouseLeave: React.MouseEventHandler<HTMLDivElement> = () => {
    if (!isDesktop || !onZoomEnd) return;
    onZoomEnd();
  };

  return (
    <div className="product-images">
      {/* Main Product Image */}
      <div
        className={`main-image-container ${isDesktop && onZoomChange ? 'desktop-zoom-enabled' : ''}`}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        <img
          src={selectedImage}
          alt={productName}
          className="main-image"
        />
      </div>

      {/* Thumbnail Images */}
      <div className="thumbnail-container">
        {thumbnailImages.map((image, index) => (
          <div
            key={index}
            className={`thumbnail-item ${selectedImage === image ? 'active' : ''}`}
            onClick={() => handleThumbnailClick(image)}
          >
            <img
              src={image}
              alt={`${productName} view ${index + 1}`}
              className="thumbnail-image"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductImages;

